import { primaryColor, dangerColor } from 'assets/jss/material-dashboard-pro-react';

const numberSettingsCardStyle = (theme) => ({
	card: {
		boxShadow: '0 8px 8px -6px rgba(0, 0, 0, 0.5)',
		display: 'flex',
		flexDirection: 'row',
		padding: '23px 18px',
		alignItems: 'center',
		justifyContent: 'flex-start',
		transition: 'all .1s ease-in-out',
		cursor: 'pointer',
		position: 'relative',
		minHeight: 115,
		'&:hover': {
			boxShadow: '0 8px 8px -6px rgba(0, 0, 0, 0.3)',
			marginTop: '14px',
			marginBottom: '18px',
		},
		'&:active': {
			boxShadow: '0 8px 8px -6px rgba(0, 0, 0, 0.6)',
			marginTop: '16px',
			marginBottom: '16px',
		},
		[theme.breakpoints.down('sm')]: {
			padding: '23px 15px',
		},
	},
	imageWrapper: {
		position: 'absolute',
		height: '40px',
		minWidth: '43px',
		maxWidth: '50px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		left: '20px',
		top: '30px',
		'& img': {
			maxHeight: '100%',
			maxWidth: '100%',
		},
		'& svg': {
			height: '100%',
			width: '100%',
			color: primaryColor[0],
		},
	},
	imageDisabled: {
		filter: 'grayscale(100%)',
	},
	textWrapper: {
		padding: '0 43px',
		textAlign: 'center',
		width: '100%',
		'& > p': {
			display: 'inline',
		},
		'& > div': {
			display: 'inline-flex',
			paddingLeft: 4,
			position: 'relative',
			top: 4,
		},
	},
	disabled: {
		cursor: 'auto',
		boxShadow: 'none!important',
		marginTop: '16px!important',
		marginBottom: '16px!important',
	},
	notAvailableText: {
		whiteSpace: 'nowrap',
		paddingBottom: 3,
	},
	notAvailable: {
		opacity: 0.5,
		cursor: 'auto',
		'&:hover': {
			boxShadow: '0 8px 8px -6px rgba(0, 0, 0, 0.5)',
			marginTop: '16px',
			marginBottom: '16px',
		},
	},
	error: {
		'& svg': {
			color: dangerColor[0],
		},
	},
	tooltipWrapper: {
		'& svg': {
			margin: 0,
			color: primaryColor[0],
		},
	},
});

export default numberSettingsCardStyle;
